<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo documento"
             col-md="col-md-4" offset="3">
    <template v-slot:modalContent>
      <form ref="docForm" @submit.prevent="submitDocForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FileUpload
                  mode="basic"
                  accept="application/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                  :multiple="true"
                  chooseLabel="Selecionar Documentos"
                  customUpload
                  @select="onSelect"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="documento.descricao_doc" size="small" style="width: 100%"/>
                <label for="descricao"><strong>Descricão do Documento: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fecharSubModal')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';


export default {
  name: 'BaseDocCadastro',
  components: {
    BaseModal,
  },
  props: {
    origemId: String,
    origemApp: String,
  },
  data() {
    return {
      documento: {
        doc: [],
        descricao_doc: ""
      },
      DocumentoSelecionado: "Escolha seu documento",
    }
  },
  emits: ['fecharSubModal', "atualizarListaDoc"],
  methods: {
    onSelect(event) {
      this.documento.doc = event.files;
    },
    async submitDocForm() {
      try {
        const form = new FormData();

        form.append('origem_id', this.origemId);
        form.append('origem_app', this.origemApp);
        form.append('descricao', this.documento.descricao_doc);
        this.documento.doc.forEach((file) => {
          form.append('documento', file);
        });

        const response = await fetch(`${process.env.VUE_APP_API_URL}documentos/create/`, {
          method: "POST",
          credentials: 'include',
          body: form
        });

        if (!response.ok) {
          const errorData = await response.json();
          this.$toastMessage("warn", "Atenção", "Error ao salvar documento!");
          console.log(errorData)
        } else {
          const novoDoc = await response.json();
          this.$emit("atualizarListaDoc", novoDoc);
          this.$toastMessage("success", "Registro salvo com sucesso!");
          this.$emit('fecharSubModal')
        }
      } catch (error) {
        this.$toastMessage("warn", "Atenção", "Error!");
        console.log(error)

      }
    },

  },
}
</script>
